import React, { useMemo } from 'react';
import CircularButton from '../../inputs/CircularButton';
import useComponentMargin from '../../hooks/useComponentMargin';
import useTheme from 'branding/theme';
import { calcOffset } from './utils';
const PageButton = ({ currentPage, label, handleClick, limit, isLink, gatsbyLink, href, styles }) => {
    const curriedHandleClick = useMemo(() => handleClick && handleClick({ offset: calcOffset(+label, limit), limit }), [label, limit, handleClick]);
    const isCurrent = currentPage === +label;
    const isEllipsis = label === '…';
    const { colors } = useTheme();
    const margin = useComponentMargin({ marginHorizontal: 'small' });
    const inactiveStyles = {
        pointerEvents: 'none'
    };
    const currentStyles = isCurrent
        ? {
            color: colors.brand.primary.alpha
        }
        : {};
    const mergedStyles = {
        ...margin,
        ...((isCurrent || isEllipsis) && inactiveStyles),
        ...styles
    };
    return (React.createElement(CircularButton, { variant: "secondary", alt: label, onClick: curriedHandleClick, styles: mergedStyles, isLink: isLink, gatsbyLink: gatsbyLink, href: href },
        React.createElement("span", { style: currentStyles }, label)));
};
export default PageButton;
//# sourceMappingURL=PageButton.js.map